import React, { FC, createContext, useContext, useMemo } from "react";
import { buildSchema } from "graphql";
import type { GraphQLSchema } from "graphql";

type FrontendApiConfigContext = {
  graphQLEndpoint: string;
  schema: GraphQLSchema;
};

const FrontendApiConfigContext = createContext<FrontendApiConfigContext | null>(
  null
);

export const useFrontendApiConfig = (): FrontendApiConfigContext => {
  const context = useContext(FrontendApiConfigContext);
  if (!context) {
    throw new TypeError(
      "Calling useFrontendApiConfig requires to be wrapped by FrontendApiConfigProvider"
    );
  }
  return context;
};

export type FrontendApiConfigProviderProps = {
  graphQLEndpoint: string;
  schema: string;
};

export const FrontendApiConfigProvider: FC<FrontendApiConfigProviderProps> = ({
  graphQLEndpoint,
  schema,
  children,
}) => {
  const builtSchema = useMemo(() => buildSchema(schema), [schema]);
  return (
    <FrontendApiConfigContext.Provider
      value={{ graphQLEndpoint, schema: builtSchema }}
    >
      {children}
    </FrontendApiConfigContext.Provider>
  );
};
